/**
 * Common helpers for CSV/PDF exports.
 * Handles V1/V2 clients, POST/GET methods, and different response shapes.
 */

/**
 * Normalize export response into a flat rows array.
 *
 * @param {any} res      – success handler input (V1: axios response, V2: extracted data)
 * @param {Object} opts
 * @param {"post"|"get"} [opts.method="post"]
 * @param {boolean} [opts.useV2=false]
 * @returns {any[]} rows array for CSV/PDF generation
 */
export function extractExportRows(res, { method = "post", useV2 = false } = {}) {
  if (method === "post") {
    if (useV2) {
      // `src/api/RequestV2` passes already-extracted data into success handler.
      const root = res ?? {};
      const content = root?.content ?? root?.data?.content ?? root;
      if (Array.isArray(content)) return content;
      return content ? [content] : [];
    }
    // V1 Request passes axios response into success handler.
    const root = res?.data ?? res ?? {};
    const content = root?.content ?? root;
    if (Array.isArray(content)) return content;
    return content ? [content] : [];
  }

  // GET: often returns array directly or under data.
  const root = res?.data ?? res ?? [];
  if (Array.isArray(root)) return root;
  return root ? [root] : [];
}

